import * as sc from "../DIGISIGN/digisignScript"
import { CommonAxiosPost } from "../CommonAxios";
import { config } from "../CommonURLS";
import Sweetalert, { successAlertEsign } from "../SweetAlerts";
import Swal from "sweetalert2";
export function digisignFunction(base64, pages, postData, getFunction, pageName) {

    let myObj = sc._elk_desksignObj
    let subjectName = "";
    let issuerName = "";
    let resellerCode = 75;
    let strHash;
    let signerName;
    let offset;
    let signerCert;
    let outfile;
    let res;
    const encodeFormData = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
            .join('&');
    };
    function preInvoke(signingfn, callback) {
        if (!myObj._elk_initialized) {
            myObj._elk_initialize(callback);
            window.setTimeout(signingfn, 200);
        }
        else
            signingfn();
    }


    function signmem() {
        myObj.ConfigSigBlock(256, 20, 30, 1, 0, "Digitally signed by", 120, 120);
        myObj.SignDataInMemoryEx("04536563", "", true, true, 0, subjectName, issuerName, "", "", false, 0, resellerCode);

    }


    function mycallback2(apiName, status, params) {
        // alert("2")
        if (apiName != "SignDataInMemoryEx")
            return;
        if (status != "Success") {
            alert("Certificate operation failed: " + status);
            // handleClose();
        }
        else {
            if (apiName == "SignDataInMemoryEx") {
                // document.getElementById("sign_loading").innerHTML="<i class='fa fa-spinner fa-spin' ></i> Registering Signature......";
                var sigholder = params.sig;
                var x = "https://digisign.apcfss.in/services/Sign/doRegister";
                let payload = {
                    sig: sigholder,
                    tbsdata: '412445',
                    project: 'jnanabhumi',
                    pkey: 'Jnb@123',
                    token_name: 'Hypersecu'
                };



                fetch("https://digisign.apcfss.in/services/Sign/doRegister", {
                    method: 'POST',
                    body: encodeFormData(payload),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.text())
                    .then(data => {

                        let res1 = data.split("*~*");
                        if (res1[0] == 1) {
                            // document.getElementById("sign_sno").value = res1[1];
                            // dispatch({ type: "DIGITOKENNO", payload: res1[1] })
                            sessionStorage.setItem("sign_sno", res1[1])
                            preInvoke(signmem, mycallback);
                        }

                    })
                    .catch(error => {
                        console.error("Error:", error);
                        // handleClose()
                    });

            }
        }

    }


    function mycallback(apiName, status, params) {
        // let method_name = '<%=request.getAttribute("ack")%>';
        if (apiName == "SignDataInMemoryEx") {
            // alert("3")
            if (typeof params.sig == "undefined" || params.sig == "") {
                let retVal = "";
            }
            else {
                if (apiName == "SignDataInMemoryEx") {
                    let retVal = params.sig;
                    let signValue = params.sig;
                    var fileURL = base64;//document.getElementById("base64").value
                    var token_no = sessionStorage.getItem("sign_sno");
                    console.log("first", token_no)

                    //document.getElementById("sign_sno").value;
                    // tokenNo;
                    //|| document.getElementById("token_sno").value;
                    //tokenNo//getData// token//;
                    var page = pages//document.getElementById("page").value;
                    //                 var oParameters = { "sig" :signValue,"MyReason":"", "MyLocation":"","SigBlockTitle":"", "PageNumber":page, "SigPosition":"10", "filetosign" :fileURL,"searchText":"Signature of Principal with college seal","coordinatex":"1",
                    // "coordinatey":"5","project":"jnanabhumi","pkey":"Jnb@123","token_name":"FT","token_sno":token_no};
                    let payload = {//
                        "sig": signValue,
                        "MyReason": "",
                        "MyLocation": "",
                        "SigBlockTitle": "",
                        "PageNumber": -1,
                        "SigPosition": "10",
                        "filetosign": fileURL,
                        "searchText": "Signature of Principal with college seal",
                        "coordinatex": "1",
                        "coordinatey": "5",
                        "project": "jnanabhumi",
                        "pkey": "Jnb@123",
                        "token_name": "FT",
                        "token_sno": token_no
                    }

                    // console.log("bakcned token ::::", tokenID, "dsk token", token_no, "sign_sno")
                    //let dotokenIn = sessionStorage.getItem('sign_sno')
                    // console.log("test", dotokenIn)
                    if (token_no !== "" || token_no !== null) {
                        fetch("https://digisign.apcfss.in/services/Sign/getCert", {
                            method: 'POST',
                            body: encodeFormData(payload),
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                        }).then(response => response.text())
                            .then(data => {
                                var res1 = data.split("*~*");
                                strHash = res1[1];
                                signerName = res1[2];
                                var signerSubjectDN = signerName;
                                offset = res1[3];
                                signerCert = res1[4];
                                outfile = res1[5];
                                res = res1[0];
                                if (res == 1)
                                    myObj.SignEncodedDataInBatch(strHash, 1, 0, 0, signerSubjectDN, "", "", "", 1, 0, resellerCode);

                            })
                            .catch(error => {
                                console.error("Error:", error);
                                // handleClose()
                            });
                    } else {
                        Sweetalert("Your DSK ID Is Not Yet Registered / InActive", "error")
                    }
                }
            }
        }
        else if (apiName == "SignEncodedDataInBatch") {
            // alert("4")
            let signValue = params.sig;//
            let payload = {
                "signature": signValue,
                "offset": offset,
                "hash": strHash,
                "signerCert": signerCert,
                "outfile": outfile,
                "project": "jnanabhumi",
                "pkey": "Jnb@123",
                "res": res
            };

            fetch("https://digisign.apcfss.in/services/Sign/signHash", {
                method: 'POST',
                body: encodeFormData(payload),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(response => response.text())
                .then(data => {

                    let res1 = data.split("*~*");
                    let signfilecontent = res1[1];
                    if (res1[0] == 1) {
                        let prevData = postData?.params
                        let payload = {
                            finalPdfPath: signfilecontent,  // pdf init value send to backend
                            ...prevData
                        }
                        postSignedPdfPathFunction(payload)

                    }

                })
                .catch(error => {
                    console.error("Error:", error);
                    // handleClose()
                });
        }
    }
    // step4. post signed pdf base64 to backend post url data >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    function postSignedPdfPathFunction(payload) {
        let posturl = postData?.path
        // CommonAxiosPost(posturl, payload).then((res) => {
        //     if (res?.data?.scode == "01") {
        //         Swal.fire({
        //             text: res?.data?.sdesc,
        //             icon: "success",
        //             backdrop: false,
        //         }).then((refresh) => {
        //             if (refresh.isConfirmed === true) {
        //                 if (pageName === "OAMDC") {
        //                     window.location.href = "/OamdcAffl_OrderGen2023"
        //                 }
        //                 if (pageName === "GOVT") {
        //                     window.location.href = "/Affl_OrderGen2022Govt"
        //                 }
        //                 if (pageName === "NONOAMDC") {
        //                     window.location.href = "/Affl_OrderGen2022"
        //                 }
        //                 else {
        //                     successAlertEsign(res?.data?.sdesc, getFunction);
        //                     let data = res?.data?.filepath;
        //                     let url = config.url.IMG_DOWNLOAD_URL + data;
        //                     let link = document.createElement('a');
        //                     link.href = url;
        //                     link.setAttribute('download', '');
        //                     document.body.appendChild(link);
        //                     link.click();
        //                 }
        //             }
        //         }

        //         )


        //     } else {
        //         failureAlert(res?.data?.ResponseDesc, "", "warning")
        //     }

        // })

        CommonAxiosPost(posturl, payload).then((res) => {
            if (res?.data?.scode === "01") {
                Swal.fire({
                    text: "FIle signed Succesfully",
                    icon: "success",
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Define navigation logic based on pageName
                        const navigationMap = {
                            "OAMDC": "/OamdcAffl_OrderGen2023",
                            "GOVT": "/Affl_OrderGen2022Govt",
                            "NONOAMDC": "/Affl_OrderGen2022",
                        };

                        const redirectUrl = navigationMap[pageName] || null;

                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                        } else {
                            // Handle default behavior if pageName doesn't match
                            successAlertEsign(res?.data?.sdesc, getFunction);
                            const data = res?.data?.filepath;
                            const url = config.url.IMG_DOWNLOAD_URL + data;
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', '');
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                });
            }
        });

    }
    return preInvoke(signmem, mycallback2);
}